import { Component, Input } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserImageDirective } from 'directives/user-image.directive';
import { UserPipe } from 'pipes/user.pipe';
import { SoftPopupComponent, TriggerSoftPopupDirective } from 'components/layout/soft-popup/soft-popup.component';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss'],
	imports: [IconComponent, TranslatePipe, UserPipe, SoftPopupComponent, TriggerSoftPopupDirective, UserImageDirective]
})
export class UserComponent {

	private _userId?: string;

	@Input() public showName = true;
	@Input() public showImage = true;
	@Input() public set userId(userId: string | undefined) {
		if (userId != this._userId) this.hasUserImage = true;
		this._userId = userId;
	}
	public get userId() { return this._userId; }
	public hasUserImage = true;
}
